import React, { Suspense, useState, useContext, useEffect } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import '../src/Styles/style.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "react-datepicker/dist/react-datepicker.css";
import loadGif from './assets/kbf_loading.gif'
import { GlobalContext } from './context'
import GlobalProvider from './context'
import { encyptedData, decryptedData } from './views/Access'
import AppRoutes from './AppRoutes'
import './Responsive.css'
import 'react-modern-drawer/dist/index.css'

const loading = (
  <div
    style={{
      width: '100vw',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    className="d-flex sk-double-bounce"
  >
    <div
      style={{
        marginTop: '-4%',
      }}
      className="d-flex flex-column"
    >
      <div className="d-flex justify-content-center">
        <img
          style={{ objectFit: 'contain', width: "200%" }}
          src={loadGif}
        />
      </div>
    </div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

function App() {
  return (
    <GlobalProvider>
    <AppRoutes />
    </GlobalProvider>
    )
}

export default App
